// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// Importar jQuery
import $ from 'jquery';
// jQuery Keywords declared
window.jQuery = $;
window.$ = $;

// Popper (Bootstrap dependency)
import * as Popper from '@popperjs/core';
window.Popper = Popper;

// Bootstrap 5
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import the specific modules you may need (Modal, Alert, etc)
import { Tooltip, Popover, Dropdown } from "bootstrap";

// Application Stylesheet (scss)
import '../stylesheets/application.scss'
import '../stylesheets/components/_megamenu.scss'
// Ensure megamenu interactivity is ready before Turbolinks fires
import './megamenu_logic'
// Import mobile menu navigation logic
import './mobile_menu_logic'
// Import tiered prices logic for shared tours
import './tiered_prices'
// Import custom JavaScript for shared tour datepicker
import './shared_tour_datepicker';

// Import tour options repeater functionality
import './tour_options_repeater';
import './booking_form_stability';
import './cookie_consent';

// Inicializar componentes de Bootstrap
document.addEventListener('turbolinks:load', function() {
  // Inicializar todos los dropdowns
  var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
  var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
    return new bootstrap.Dropdown(dropdownToggleEl);
  });

  // Inicializar tooltips
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Inicializar popovers
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
  });
});

// Import custom JS
document.addEventListener('turbolinks:load', function() {
  import("./initialize").then(() => console.log('initialize loaded'));
  import("./form_toggle").then(() => console.log('form_toggle loaded'));
  import("./sidebar").then(() => console.log('sidebar loaded'));
  import("./smooth_scroll").then(() => console.log('smooth_scroll loaded'));
  
  import("./toggle_private_tour").then(() => console.log('toggle_private_tour loaded'));
  import("./show_hide_hostel_select").then(() => console.log('show_hide_hostel_select loaded'));
  import("./sortable").then(() => console.log('sortable loaded'));
});

Rails.start()
Turbolinks.start()
ActiveStorage.start()

require("trix")
require("@rails/actiontext")


import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';

document.addEventListener('turbolinks:load', function() {
  const calendarEl = document.getElementById('calendar');
  
  if (calendarEl) {
    const cityPrivateTourId = calendarEl.getAttribute('data-tour-id'); // Obtén el ID desde el data attribute
  
    const calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      selectable: true,
      events: `/city_private_tours/${cityPrivateTourId}/blocked_dates`, // Usa el ID de la URL correctamente
      select: function(info) {
        const confirmBlock = confirm(`Do you want to toggle the blocked status for this date: ${info.startStr}?`);
        if (confirmBlock) {
          fetch(`/city_private_tours/${cityPrivateTourId}/toggle_blocked_date`, { // URL con el ID de la URL correctamente
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({ date: info.startStr })
          }).then(() => {
            calendar.refetchEvents();
          });
        }
      }
    });
    calendar.render();
  }
});

